import type { FramingHint as Hint } from '@/capture/useFramingHints';
import { useT } from '@/i18n/runtime';
import { Icon, type IconName } from './Icon';

const ICON: Record<Hint, IconName> = { dark: 'sun', moving: 'hand', closer: 'face', back: 'face' };

/** One advisory line under the instruction card: icon + ≤ 4 words (SPEC_CAPTURE_UX_R2 §5, P4/P5). Never a gate. */
export function FramingHintLine({ hint }: { hint: Hint | null }): JSX.Element | null {
  const { t } = useT();
  if (!hint) return null;
  // <output> carries the implicit "status" role — the semantic element, not a div with a role.
  return (
    <output className="sv-hint" data-testid="framing-hint" data-hint={hint} aria-live="polite">
      <Icon name={ICON[hint]} size={14} />
      <span>{t(`sv.hint.${hint}`)}</span>
    </output>
  );
}
